import React, { useRef, useState, useEffect } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { Modal } from 'react-bootstrap';
import Button from '@mui/material/Button';
import { api_host } from '../apiClient';
import './componentStyle.css';

interface DatabaseModalFormProps {
  showDatabaseModal: boolean;
  setShowDatabaseModal: Function;
};

export default function DatabaseModalForm({
  showDatabaseModal,
  setShowDatabaseModal,
}: DatabaseModalFormProps) {

  // query client
  const queryClient = useQueryClient();

  // loading state
  const [isLoading, setIsLoading] = useState(false);

  // disable/enable submit button
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);

  // handling SSE output
  const [output, setOutput] = useState('');

  const handleSubmit = (e: React.MouseEvent) => {
    e.preventDefault();

    setIsLoading(true);
    setIsSubmitDisabled(true);
    setOutput('Processing... Please wait.\n\n');

    const eventSource = new EventSource(api_host + '/sigcap/api/run-database-update/', {
      withCredentials: true
    });

    eventSource.onmessage = (event) => {
      setOutput((prevOutput) => prevOutput + event.data + '\n');
      if (event.data.includes("Processed ")) {
        eventSource.close();
        setIsSubmitDisabled(false);
        setIsLoading(false);
      }
    };

    eventSource.onerror = (error) => {
      console.error("Error:", error);
      eventSource.close();
      setIsSubmitDisabled(false);
      setIsLoading(false);
    };

  };

  // set outputRef to control overflow/scroll
  const outputRef = useRef<HTMLPreElement>(null);

  // Auto-scroll to bottom when output changes
  useEffect(() => {
    if (outputRef.current) {
      outputRef.current.scrollTop = outputRef.current.scrollHeight;
    }
  }, [output]);

  return (
    <Modal
      show={showDatabaseModal}
      // close modal when pressing X button at the top right
      onHide={() => {
        setShowDatabaseModal(false);
        setIsSubmitDisabled(false);
        setOutput('');
        // refetch data
        queryClient.invalidateQueries({ queryKey: ['sigcap_datatable'] });
      }}
      // for setting modal width
      dialogClassName="update-atabase-modal"
      centered={false}
      // prevent from closing when pressing outside of this modal
      backdrop="static"
    >
      <Modal.Header closeButton>
        <Modal.Title>Update Database</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div>
          Messages:
          <div
            className="alert alert-info"
            style={{
              height: '20em',
              overflowY: 'auto',
            }}
          >
            <pre
              ref={outputRef}
              style={{
                margin: 0,
                height: '100%',
                overflowY: 'auto',
              }}
            >
              {output}
            </pre>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outlined"
          color="primary"
          style={{ marginRight: '1em' }}
          onClick={() => {
            setShowDatabaseModal(false);
            setIsSubmitDisabled(false);
            // refetch data
            queryClient.invalidateQueries({ queryKey: ['sigcap_datatable'] });
          }}
        >
          Close
        </Button>
        <Button
          variant="contained"
          color="primary"
          type="submit"
          disabled={isSubmitDisabled}
          onClick={handleSubmit}
        >
          {isLoading ? 'Updating...' : 'Update'}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
